import { ReactComponent as Demo1 } from "../image/demo_1.svg";
import { ReactComponent as Demo2 } from "../image/demo_2.svg";

export const NEWS_LIST_MOCK = [
  {
    body: `
    <ol>
    <li>SMCI shares increased after investigation cleared misconduct allegations.</li>
    <li>External experts confirmed no need for financial restatements for SMCI.</li>
    <li>Positive findings could enhance investor confidence in SMCI stock.</li>
    </ol>
    `,
    id: 1,
    Image: Demo1,
    minutes: 29,
    sources: 7,
    tags: [
      { label: "SMCI" },
      { background: "#D1EBAC", color: "#026F00", label: "Short Term Bullish" },
      { label: "Corporate Developments" },
    ],
    title: "Super Micro Computer Surges as Committee Finds No Misconduct",
  },
  {
    body: `
    <ol>
    <li>Stellantis CEO Carlos Tavares resigns abruptly amid board disagreements.</li>
    <li>New CEO search is expected to be completed within six months.</li>
    <li>Leadership change may impact investor confidence and company strategy.</li>
    </ol>
    `,
    id: 2,
    Image: Demo2,
    minutes: 29,
    sources: 55,
    tags: [
      { label: "STLA" },
      { background: "#FFE7E7", color: "#BA0202", label: "Short Term Bearish" },
      { label: "Corporate Developments" },
    ],
    title: "Stellantis CEO Carlos Tavares Resigns Amid Company Struggles",
  },
];
